import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import classNames from 'classnames';
import isNumber from 'lodash-es/isNumber';
import isString from 'lodash-es/isString';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback, useEffect } from 'react';

var styles = {"container":"panneau-display-image-container","inner":"panneau-display-image-inner"};

var propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  onClick: PropTypes.func,
  withZoom: PropTypes.bool,
  // withModal: PropTypes.bool, // TODO
  className: PropTypes.string
};
var defaultProps = {
  value: null,
  placeholder: null,
  maxWidth: 40,
  maxHeight: 40,
  onClick: null,
  withZoom: false,
  // withModal: false,
  className: null
};
var Image = function Image(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    maxWidth = _ref.maxWidth,
    maxHeight = _ref.maxHeight,
    onClick = _ref.onClick,
    withZoom = _ref.withZoom,
    className = _ref.className;
  var _ref2 = value || {},
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url,
    _ref2$thumbnailUrl = _ref2.thumbnailUrl,
    thumbnailUrl = _ref2$thumbnailUrl === void 0 ? null : _ref2$thumbnailUrl,
    _ref2$thumbnail_url = _ref2.thumbnail_url,
    altThumbnailUrl = _ref2$thumbnail_url === void 0 ? null : _ref2$thumbnail_url,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? null : _ref2$description,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? null : _ref2$name;
  var defaultValue = isString(value) ? value : null;
  var image = useMemo(function () {
    return altThumbnailUrl || thumbnailUrl || url || defaultValue;
  }, [altThumbnailUrl, thumbnailUrl, url, defaultValue]);
  var Tag = onClick !== null ? 'button' : 'div';
  var isButton = Tag === 'button';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    zooming = _useState2[0],
    setZooming = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    zoomed = _useState4[0],
    setZoomed = _useState4[1];
  var onHoverIn = useCallback(function () {
    setZooming(true);
  }, [setZooming]);
  var onHoverOut = useCallback(function () {
    setZooming(false);
  }, [setZooming]);
  useEffect(function () {
    if (!zooming) {
      setZoomed(false);
    }
    var id = setTimeout(function () {
      setZoomed(zooming);
    }, 290);
    return function () {
      clearTimeout(id);
    };
  }, [zooming]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, withZoom && image !== null ? {
    onMouseEnter: onHoverIn,
    onMouseLeave: onHoverOut
  } : null), /*#__PURE__*/React.createElement(Tag, Object.assign({
    className: classNames(['position-relative d-flex align-items-center justify-content-center', styles.inner, {
      'btn border-radius-0': isButton
    }]),
    style: _objectSpread({
      width: maxWidth !== null && isNumber(maxWidth) ? parseInt(maxWidth, 10) : maxWidth,
      height: maxHeight !== null && isNumber(maxHeight) ? parseInt(maxHeight, 10) : maxHeight,
      transition: 'transform 0.15s ease-out'
    }, zoomed ? {
      position: 'absolute',
      transform: 'scale(3.4)',
      zIndex: 10
    } : null)
  }, isButton ? {
    type: 'button',
    onClick: onClick
  } : null), image !== null ? /*#__PURE__*/React.createElement("img", {
    className: classNames(['d-block mw-100 mh-100 object-fit-contain', styles.image]),
    src: image,
    alt: description || name
  }) : placeholder));
};
Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export { Image as default };
